import React from 'react';
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ReactHtmlParser from "react-html-parser";

const SalesMenu = ({ collections }) => {
    return (
        <div className="top-nav">
            <Container>
                <Row>
                    <Col xl={{ span: 2, offset: 1 }} lg={{ span: 3, offset: 0 }} >
                        <h4 className="top-nav__nav-title">Collections</h4>
                        <Nav className="top-nav__nav-list">
                            {collections.map((collection) => {
                                return (
                                    <Nav.Item
                                        key={collection.title}
                                        className="top-nav__nav-list-item-primary nav-link nav-top-link"
                                        as="a"
                                        href={collection.url}
                                    >
                                        {collection.title}
                                    </Nav.Item>
                                )
                            })}
                        </Nav>
                    </Col>
                    <Col lg={3}>
                        <MagazineArticle key="article-last" article={collections[0]} />
                    </Col>
                    <Col lg={3}>
                        <MagazineArticle key="article-before-last" article={collections[1]} />
                    </Col>
                    <Col lg={3}>
                        <MagazineArticle key="article-after-last" article={collections[2]} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const MagazineArticle = ({ article }) => {
    return (
        <div className="top-nav__sale">
            <a href={article.url}>
                <div className="top-nav__sale-img">
                    <img
                        alt={article.title}
                        src={article.image}
                        title={article.title}
                    />
                </div>
                <div className="top-nav__sale-text">
                    <h2 className="top-nav__sale-title top-nav__sale-title--caps">
                        {article.title}
                    </h2>
                    <div className="top-nav__sale-excerpt">{ReactHtmlParser(article.sub_title)}</div>
                    <div className="top-nav__sale-cta">
                        {article.cta_label}
                    </div>
                </div>
            </a>
        </div>
    )
}

export default SalesMenu;